import { render, staticRenderFns } from "./S8swiper.vue?vue&type=template&id=6f89f58c&scoped=true&"
import script from "./S8swiper.vue?vue&type=script&lang=js&"
export * from "./S8swiper.vue?vue&type=script&lang=js&"
import style0 from "./S8swiper.vue?vue&type=style&index=0&id=6f89f58c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f89f58c",
  null
  
)

export default component.exports